import React from 'react';
import { PlanType, Tool } from './types';
import toolsData from './data/tools.json';
import { normalizeTool } from './utils/normalizeTool';

export const RAW_AI_TOOLS = toolsData as Record<string, any>[];
const seenToolIds = new Set<string>();
export const AI_TOOLS: Tool[] = RAW_AI_TOOLS
  .map(normalizeTool)
  .filter((tool) => {
    if (seenToolIds.has(tool.id)) {
      return false;
    }

    seenToolIds.add(tool.id);
    return true;
  });

export const LOGO_SVG = (
  <svg className="w-8 h-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
);

export const CATEGORIES = [
  "Marketing & Growth",
  "Analytics, BI & Reporting",
  "Data Extraction (Scraping & Mining)",
  "Creative, Images & Media AI",
  "Data Processing & Enrichment",
  "Automation & Workflow Engines",
  "AI & Intelligence",
  "Outreach & Engagement",
  "Lead Generation & Prospecting",
  "Security, Compliance & Validation"
];

export const PRICING_PLANS = {
  [PlanType.FREE]: {
    id: PlanType.FREE,
    priceMonthly: 0,
    priceYearly: 0,
    credits: 100,
    bots: 1,
    storageGb: 1,
    ipRotation: false,
    support: 'Community'
  },
  [PlanType.PRO]: {
    id: PlanType.PRO,
    priceMonthly: 99,
    priceYearly: 79,
    credits: 15000,
    bots: 8,
    storageGb: 40,
    ipRotation: true,
    support: 'Priority'
  },
  [PlanType.PRO_PLUS]: {
    id: PlanType.PRO_PLUS,
    priceMonthly: 499,
    priceYearly: 399,
    credits: 100000,
    bots: 50,
    storageGb: 500,
    ipRotation: true,
    support: '24/7 Dedicated'
  }
};
